import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  DigitalSubmissionRatio,
  GroundTruthRatio,
} from '../../../redux/types';
import { Colors } from '../../utilities/Colors';

type Props = {
  exerciseGroundTruth: GroundTruthRatio;
  submission?: DigitalSubmissionRatio;
}

function ratioScoreEvaluation(gtPayload: GroundTruthRatio['payload'], userAnswer: DigitalSubmissionRatio['answer']) {
  const { answer, score } = gtPayload;
  let answerMeta = { score: 0, status: 'wrong' };
  if (answer[0] === userAnswer[0] && answer[1] === userAnswer[1] && !!answer[0] && !!answer[1]) {
    answerMeta = { score, status: 'correct' };
  }
  return answerMeta;
}

const RevealedAnsRatio: React.FC<Props> = ({
  exerciseGroundTruth,
  submission,
}: Props) => {
  const evaluateString = (gt: GroundTruthRatio, sb?: DigitalSubmissionRatio) => {
    const { status } = ratioScoreEvaluation(gt.payload, sb?.answer || [0, 0]);
    return status;
  };

  const finalAnswer = evaluateString(exerciseGroundTruth, submission);

  return (
    <Box aria-label="exercise-answer-string">
      {
        finalAnswer !== null && finalAnswer !== undefined && (
          <Box>
            {
              finalAnswer === 'wrong' && (
                <Typography style={{ color: Colors.wrong, fontWeight: 500 }} component="div">Wrong Answer</Typography>
              )
            }
            {
              (finalAnswer === 'correct' || finalAnswer === 'acceptable') && (
                <Typography style={{ color: Colors.correct, fontWeight: 500 }} component="div">Correct Answer</Typography>
              )
            }
          </Box>
        )
      }
      {
        exerciseGroundTruth.payload && (
          <Box display="flex" gap={2}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              color="GrayText"
              maxWidth={250}
            >
              {`${exerciseGroundTruth.payload.answer[0]}:${exerciseGroundTruth.payload.answer[1]}`}
            </Typography>
          </Box>
        )
      }
    </Box>
  );
};

export default RevealedAnsRatio;
